import axios from "axios";

export class MainService {
    static BASE_URL = "https://painelcrm.rxy.com.br/api/v3";
    // static BASE_URL = "http://localhost:4050";
    static async loadQuestions(surveyId) {
        try {
            const survey = await axios.get(
                `${this.BASE_URL}/surveys/${surveyId}`,
                {
                    headers: {
                        "x-api-key": "c6ac0b97-100b-40ff-9f69-015943c33709",
                    },
                }
            );

            if (survey.data.data.message) {
                return {
                    answered: true,
                };
            } else {
                return survey.data.data.survey;
            }
        } catch (error) {
            console.error(error);
            return null;
        }
    }

    static async saveAnswers(surveyId, answers) {
        try {
            let URL = `${this.BASE_URL}/surveys/${surveyId}`;

            const postResponse = await axios.post(
                encodeURI(URL),
                {
                    surveyId: surveyId,
                    surveyAnswers: answers,
                },
                {
                    headers: {
                        "x-api-key": "c6ac0b97-100b-40ff-9f69-015943c33709",
                    },
                }
            );

            return postResponse.status === 201;
        } catch (error) {
            console.error(error);
            return false;
        }
    }
}
